import styled from 'styled-components';
import { PopoverContent } from 'components/popovers/popover';

export const IndicatorButton = styled.button.attrs({
  type: 'button',
  className:
    'flex h-8 items-center gap-1 rounded-md border border-destructive/20 bg-destructive/10 px-2 text-xs font-bold text-destructive cursor-pointer hover:opacity-80 transition-opacity',
})``;

export const OverlayContent = styled(PopoverContent).attrs({
  className: 'w-[36rem] max-w-[calc(100vw-2rem)] p-3',
})``;

export const Heading = styled.h2.attrs({
  className: 'mb-2 text-sm font-medium text-muted-foreground',
})``;

export const List = styled.div.attrs({
  className: 'flex max-h-[60vh] flex-col gap-2 overflow-y-auto p-1',
})``;

export const Sentinel = styled.div.attrs({
  className: 'h-px w-full shrink-0',
})``;
